import React from "react";
import { Link } from "react-router-dom";
import { Ornament } from "./Ornament";
import { CLIENTS } from "../data/content";
import { Heart, PartyPopper, Building2, Hotel, Megaphone, MapPin } from "lucide-react";

const iconMap = {
  heart: Heart,
  "party-popper": PartyPopper,
  "building-2": Building2,
  hotel: Hotel,
  megaphone: Megaphone,
  "map-pin": MapPin,
};

export default function Clients() {
  return (
    <section
      id="clients"
      className="relative bg-[var(--lu-ivory)] py-24 lg:py-32"
      data-testid="clients-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="font-micro text-[10px] text-[var(--lu-gold-dark)]">Who we work with</p>
          <h2 className="mt-3 h-editorial text-[46px] sm:text-[60px] lg:text-[78px] text-[var(--lu-black)] leading-[1.05]">For every moment<span className="italic text-[var(--lu-gold-dark)]">which is worth watching.</span>
          </h2>
          <Ornament className="my-8 justify-start" />
          <p className="text-[15px] leading-[1.9] text-black-75 max-w-md">From intimate villas to international activations, we design entertainment
            for hosts who pay attention to every detail — and for
            brands that want their story to be told in style.</p>
          <div className="mt-10 h-40 aspect-[3/1] w-full tile">
            <img
              src="/generated/golden-performer-1.jpg"
              alt="Luxury clients"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {CLIENTS.map((c, i) => {
              const Icon = iconMap[c.icon];
              return (
                <Link
                  key={c.name}
                  to={`/events/${c.slug}`}
                  className="flex items-center gap-5 border border-[var(--lu-gold-dark)]/40 p-6 hover:border-[var(--lu-gold-dark)] hover:bg-[var(--lu-cream)] hover:-translate-y-1 transition-all duration-500"
                  data-testid={`client-${i}`}
                >
                  <span className="w-12 h-12 flex items-center justify-center border border-[var(--lu-gold-dark)] rounded-full">
                    <Icon size={20} className="text-[var(--lu-gold-dark)]" />
                  </span>
                  <div>
                    <p className="font-serif text-[24px] text-[var(--lu-black)] leading-tight">
                      {c.name}
                    </p>
                    <p className="font-micro text-[9px] text-[var(--lu-gold-dark)] mt-1">Bespoke concept &amp; implementation</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
